import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import formatTimestamp from 'utils/formatTimestamp'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { NavLink } from 'react-router-dom'
import { OrderedMap } from 'immutable'

import QueuesPagination from './queues-pagination'

// Modules
import { actions as queuesActions, selectors } from 'modules/queues'
import { LINKS_LIST_PATH } from 'config'


export class Queues extends Component {
  static propTypes = {
    currentQueueId: PropTypes.string,
    loadQueues: PropTypes.func.isRequired,
    queues: PropTypes.instanceOf(OrderedMap).isRequired,
    site: PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.loadSiteQueues()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.site.key !== nextProps.site.key) {
      this.loadSiteQueues(nextProps.site.key)
    }
  }

  loadSiteQueues = siteId => {
    const { loadQueues, site } = this.props

    loadQueues(siteId || site.key)
  }

  render() {
    const { queues, site } = this.props;
    const hasQueues = Boolean(queues && queues.size);

    return (
      <div className={ classNames('queues-menu', { 'card': hasQueues }) }>
        {
          hasQueues && (
            <ul className="queues-menu__list nav nav-pills flex-column" style={ { overflow: 'auto' } }>
              {
                queues.map((queueItem, key) => {
                  const firstQueue = queueItem.first();
                  const linksListPath = LINKS_LIST_PATH.replace(':site', site.key).replace(':queue', key);

                  return (
                    <li className="nav-item" key={ key }>
                      <NavLink to={ linksListPath } className="nav-link" activeClassName="active">
                        { formatTimestamp(firstQueue && firstQueue.timestamp) }
                      </NavLink>
                    </li>
                  )
                }).toArray()
              }
            </ul>
          )
        }
        <QueuesPagination />
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  queues: selectors.getPaginatedSiteQueues,
})

export default connect(mapStateToProps, queuesActions)(Queues)



// WEBPACK FOOTER //
// ./src/components/queues/queues.js